import { Header } from "@/components/features/layout/header";
import { useEffect, useRef } from "react";
import "./lp.css";
import lpHtml from "./lp-content.html?raw";

const STICKY_HEADER_OFFSET = "88px";
const REVEAL_STAGGER_MS = 90;

const noop = () => {};

// アンカー遷移時に sticky header 分のオフセットを確保（元 LP は html に設定）。
// /lp 滞在中だけ documentElement に適用し、離脱時に元へ戻す。
function setupScrollPadding(): () => void {
  const docEl = document.documentElement;
  const prevPadding = docEl.style.scrollPaddingTop;
  const prevBehavior = docEl.style.scrollBehavior;
  docEl.style.scrollPaddingTop = STICKY_HEADER_OFFSET;
  docEl.style.scrollBehavior = "smooth";
  return () => {
    docEl.style.scrollPaddingTop = prevPadding;
    docEl.style.scrollBehavior = prevBehavior;
  };
}

// スクロールで .reveal 要素に .in を付与して表示する（未付与だと opacity:0 のまま）。
function setupRevealOnScroll(root: HTMLElement): () => void {
  const revealEls = root.querySelectorAll<HTMLElement>(".reveal");
  const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
  if (reduce || !("IntersectionObserver" in window)) {
    for (const el of revealEls) el.classList.add("in");
    return noop;
  }
  const io = new IntersectionObserver(
    (entries) => {
      for (const en of entries) {
        if (!en.isIntersecting) continue;
        const el = en.target as HTMLElement;
        const sibs = Array.from(el.parentElement?.children ?? []).filter((c) =>
          c.classList.contains("reveal")
        );
        const idx = sibs.indexOf(el);
        el.style.transitionDelay = `${idx > 0 ? idx * REVEAL_STAGGER_MS : 0}ms`;
        el.classList.add("in");
        io.unobserve(el);
      }
    },
    { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
  );
  for (const el of revealEls) io.observe(el);
  return () => io.disconnect();
}

export function LpPage() {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const cleanups = [setupScrollPadding(), setupRevealOnScroll(root)];
    return () => {
      for (const fn of cleanups) fn();
    };
  }, []);

  return (
    <>
      <Header mode="marketing" />
      <div
        className="lp-root"
        ref={rootRef}
        // biome-ignore lint/security/noDangerouslySetInnerHtml: lp.html(自社デザインLP)の静的マークアップをそのまま描画するため
        dangerouslySetInnerHTML={{ __html: lpHtml }}
      />
    </>
  );
}
